
import { ElMessageBox } from 'element-plus';
import { ElMessage } from 'element-plus';
import { ElNotification } from 'element-plus'
import { Actions } from "@/store/enums/StoreEnums";
import store from "@/store";
import router from '@/router';
import moment from "moment";
import {ProgressFinisher, useProgress} from '@marcoschulte/vue3-progress';
import axios from "axios";
moment.locale("es");
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export const errManager = (response: any, target = null, mode = 1) => {
    if (!response)
        ElMessage({ showClose: true, message: 'Oops, no se ha recibido información del error para ser procesado.', type: 'error' })

    const status = response.status
    const title = (status === 401) ? "Seguridad del Sistema" : `Error ${response.status} [${response.statusText}]`
    let message = ''

    if(status === 403) //acceso prohibido
       return router.push("/403")

    if (status === 401) {
        message = response.statusText
    } else if (typeof response.data == 'string') {
        message = response.data
    } if (typeof response.data === 'object') {
        if (Object.prototype.hasOwnProperty.call(response.data, 'message'))
            message = response.data.message
        else if (Object.prototype.hasOwnProperty.call(response.data, 'messages'))
            message = response.data.messages.error
        else
            message = 'No se tiene información del error.'
    }


    /*Swal.fire({
        title: title,
        html: message,
        icon: "error",
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "Entendido",
        customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
        },
    }).then(function () {
        if (status === 401){
            store
                .dispatch(Actions.LOGOUT)
                .then(() => {
                    router.push("/sign-in")
                });
        }
    })*/

    if(mode == 1)
        ElMessageBox.alert(message, title, {
            type: 'warning',
            confirmButtonText: 'Entendido',
            dangerouslyUseHTMLString: true,
            callback: action => {
                if (status === 401){
                    store
                        .dispatch(Actions.LOGOUT)
                        .then(() => {
                            router.push("/sign-in")
                        });
                }
                    
            }
        })

    if(mode == 2)
        ElNotification({
            title: title,
            message: message,
            type: 'warning',
        })
}

export const showNotification = (data) => {
    ElNotification({
        title: data.title,
        message: data.message,
        type: data.status,
    })
}

export const dateParticipate = (date1: any, date2: any) => {
    if (date1 && date2) {
      let dat1 = moment(date1).format("DD MMM");
      let dat2 =
        moment(date1).format("DD/MM/YYYY") !=
        moment(date2).format("DD/MM/YYYY")
          ? " al " + moment(date2).format("DD MMM YYYY")
          : "";

      return dat1 + `<span>${dat2}</span>`;
    } else {
      return "Sin información";
    }
};

export const mbtoa = (value) => {
    return btoa(value)
}

export const DownloadXLSXPDF = (ext, target, payload) => {
    const progresses = [] as ProgressFinisher[];
    progresses.push(useProgress().start());
    let params = new URLSearchParams(payload);
    axios({
        url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fURL = document.createElement('a');
        var nameFile = moment().format() + "." +ext

        fURL.href = fileURL;
        fURL.setAttribute('download', nameFile);
        document.body.appendChild(fURL);
        fURL.click();
        progresses.pop()?.finish();
    }).catch( (err) => {
        progresses.pop()?.finish();
        errManager(err)
    })
}

export const showMessage = (data) => { 

    const className = data.status == 'error' ? 'danger' : data.status

    Swal.fire({
        title: data.title,
        html: data.message,
        icon: data.status,
        buttonsStyling: false,
        allowOutsideClick: false,
        confirmButtonText: "Entendido",
        customClass: {
            confirmButton: `btn fw-bold btn-light-${className}`,
        },
    })
}

export const validFormatImg = (data) : boolean => {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png'];
    return allowedFormats.includes(data);
}

export const validFormatImgPDF = (data) : boolean => {
    const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];
    return allowedFormats.includes(data);
}

export const cBoolean = (val) : boolean => {
    return val === "1"
}




//export default {errManager}